<template>
  <div class="offcanvas-wrapper" id="yahooProductDetail" v-if="product">
    <div class="page-title">
      <div class="container">
        <div class="column">
          <h1>{{ $t('amazon.product_detail') }}</h1>
        </div>
        <div class="column">
          <ul class="breadcrumbs">
            <li>
              <router-link to="/">{{ $t('nav.home') }}</router-link>
            </li>
            <li class="separator"></li>
            <li>
              <router-link :to="{ name: 'yahoo' }">{{ $t('shop_names.amazon') }}</router-link>
            </li>
            <li class="separator"></li>
            <!--<li>{{ product.Headline }}</li>-->
          </ul>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
  import { getLoadingInstance } from '@/plugins/helpers';

  export default {
    name: 'AmazonProductDetail',
    data: () => ({
      product: null,
    }),
    mounted() {
      this.init();
    },
    methods: {
      init() {
        this.itemCode = this.$route.params.code;
        const loading = getLoadingInstance({
          text: '加载中...',
        });
        this.$store.dispatch('fetchAmazonItem', this.itemCode).then(() => {
          loading.close();
        });
      },
    },
  };
</script>

<style scoped>

</style>
